import { CreatePOComponent } from './create-po.component';

export default CreatePOComponent;
